var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n        .Warning-st0 {\r\n            fill: currentColor;\r\n        }\r\n    ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Warning-st0",
    d: "M15.8,12.7L9.8,1.4C9.3,0.4,8,0,7,0.6C6.7,0.8,6.4,1.1,6.2,1.4L0.2,12.7c-0.5,1-0.1,2.2,0.9,2.8 c0.3,0.2,0.6,0.2,1,0.2h11.9c1.1,0,2.1-0.9,2.1-2C16,13.3,15.9,13,15.8,12.7z M8,13.7c-0.6,0-1-0.4-1-1s0.4-1,1-1c0.6,0,1,0.4,1,1 S8.6,13.7,8,13.7z M8.4,10.3H7.6c-0.2,0-0.3-0.1-0.3-0.3L7,5.4C7,5.2,7.2,5,7.4,5h1.3C8.8,5,9,5.2,9,5.4L8.7,10 C8.7,10.2,8.5,10.3,8.4,10.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.ba314dfa9ff9c99e1abde750e22ff6b4.svg";
export { ForwardRef as ReactComponent };